import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, slice } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';

import ActivityCard from 'components/project/activity_card';
import { newLeadActivity } from 'bundles/project/actions/lead_tasks';
import { activitiesForLead } from 'bundles/project/selectors/leads';

export class ActivityFeed extends React.Component {
  static propTypes = {
    activities: PropTypes.arrayOf(PropTypes.shape({
      assignee: PropTypes.string,
      assigneeImageUrl: PropTypes.string,
      assigneeInitials: PropTypes.string,
      associatedModels: PropTypes.arrayOf(PropTypes.shape({
        associatedModelType: PropTypes.string.isRequired
      })).isRequired,
      body: PropTypes.string,
      completedAt: PropTypes.string,
      hasCrmEmail: PropTypes.bool,
      id: PropTypes.number.isRequired,
      pinned: PropTypes.bool,
      taskType: PropTypes.string.isRequired,
      title: PropTypes.string
    })),
    lead: PropTypes.object,
    onNew: PropTypes.func.isRequired
  };

  state = {
    showAllActivities: false
  }

  shownActivities() {
    const { activities } = this.props;
    const { showAllActivities } = this.state;

    if (!showAllActivities && activities.length > 5) {
      return slice(activities, 0, 5);
    } else {
      return activities;
    }
  }

  toggleShowAllActivities = () => {
    const { showAllActivities } = this.state;
    this.setState({ showAllActivities: !showAllActivities });
  }

  handleNew = (e) => {
    e.preventDefault();
    this.props.onNew(this.props.lead);
  };

  render() {
    return (
      <React.Fragment>
        {this.renderHeader()}
        {this.renderActivities()}
      </React.Fragment>
    );
  }

  renderHeader() {
    return (
      <div className="mb-3">
        <div className="pull-right">
          <button className="btn btn-link p-0" name="add-activity-button" onClick={this.handleNew}>
            + New Activity
          </button>
        </div>
        <FontAwesomeIcon className="mr-2" fixedWidth icon={faBolt} size="1x" />
        <span className="h3">Activities</span>
      </div>
    );
  }

  renderToggleShowMore() {
    const { activities } = this.props;
    const { showAllActivities } = this.state;

    if (activities.length <= 5) return;

    const [icon, phrase] = showAllActivities ? [faChevronUp, 'See Less'] : [faChevronDown, 'See More'];

    return (
      <div className="text-center">
        <a className="clickable" onClick={this.toggleShowAllActivities}>
          {phrase}
          <FontAwesomeIcon className="ml-2" icon={icon} size="1x" />
        </a>
      </div>
    );
  }

  renderActivities() {
    const { activities } = this.props;

    if (!activities || activities.length === 0) {
      return (
        <React.Fragment>
          <hr className="mt-0 mb-2" />
          <p className="text-muted pl-2" name="no-activities-message">No activities found.</p>
        </React.Fragment>
      );
    }
    const activityCards = map(this.shownActivities(), activity => (
      <ActivityCard
        activityType={activity.taskType}
        associatedModels={activity.associatedModels.filter(model => model.associatedModelType.includes('Contacts'))}
        author={activity.assignee}
        authorImageUrl={activity.assigneeImageUrl}
        authorInitials={activity.assigneeInitials}
        body={activity.body}
        hasCrmEmail={activity.hasCrmEmail}
        key={activity.id}
        name={`lead-activity-${activity.id}-card`}
        pinned={activity.pinned}
        timestamp={activity.completedAt}
        title={activity.title}
      />
    ));

    return (
      <React.Fragment>
        {activityCards}
        {this.renderToggleShowMore()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  activities: activitiesForLead(ownProps.lead, state.tasks)
});

const mapDispatchToProps = {
  onNew: newLeadActivity
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityFeed);
